import { createStore } from 'vuex'
import shareEarn from './shareEarn'
import shareService from './shareService'
import ticket from './ticket'
import channel from './channel'
import travelConfigure from './travelConfigure'
import { queryShareKey, queryUserInfo } from '@/api/common'
import { StoreInfoType, UserInfoType } from '@/constant/common'
import { CityType, defaultCity } from '@/utils'

interface stateType {
  keepAliveRoutes: string[]
  userInfo: UserInfoType | null
  userShareKey: string
  storeInfo: StoreInfoType | null
  cityInfo: CityType
}
export default createStore({
  state: {
    keepAliveRoutes: [],
    userInfo: null,
    userShareKey: '',
    storeInfo: null,
    cityInfo: defaultCity
  },
  mutations: {
    setKeepAliveRoutes(state: stateType, keepAliveRoutes: string[]) {
      state.keepAliveRoutes = keepAliveRoutes
    },
    setUserInfo(state: stateType, userInfo: UserInfoType) {
      state.userInfo = userInfo
    },
    setUserShareKey(state: stateType, userShareKey: string) {
      state.userShareKey = userShareKey
    },
    setStoreInfo(state: stateType, storeInfo: StoreInfoType) {
      state.storeInfo = storeInfo
    },
    setCityInfo(state: stateType, cityInfo: CityType) {
      state.cityInfo = cityInfo
    }
  },
  actions: {
    async queryUserInfo({ commit }, { visitkey, padetail, pregnant } = {}) {
      const userInfo = await queryUserInfo({
        visitkey,
        padetail,
        pregnant
      })
      commit('setUserInfo', userInfo)
      return userInfo
    },
    async queryShareKey({ commit }, params = {}) {
      const userShareKey = await queryShareKey(params)
      commit('setUserShareKey', userShareKey)
      return userShareKey
    }
  },
  modules: {
    shareEarn,
    shareService,
    ticket,
    channel,
    travelConfigure
  }
})
